


import React, { Fragment } from "react";
import { useHprSettings } from "../../data/hprSettings/useHprSettings";
import { ICert } from "../../models/ICert";


type IRenderProps = { cert: ICert | null };

interface RenderCertProps {
    referenceName: string;
    render: (props: IRenderProps) => any;
};

export const RenderCert: React.FC<RenderCertProps> = ({ referenceName, render }) => {
    const { data: settings } = useHprSettings();
    const cert = settings?.certs && settings.certs[referenceName];

    return (
        <Fragment>
            {render({ cert: cert || null })}
        </Fragment>
    );
};

